$(function () {
  $(document).on('click','.tab-queues li', function (event) {
    let tab = $(event.currentTarget);
    $('.content-convert').removeClass('show').addClass('hide');
    $('#' + tab.data('name')).addClass('show').removeClass('hide');
    $('.tab-queues li').removeClass('active');
    tab.addClass('active');
  });
})
